import React from 'react';
import { useParams } from 'react-router-dom';
import ItineraryOverview from '../components/trips/ItineraryOverview';
import DetailsForm from '../components/trips/DetailsForm';

export function ItineraryOverviewRoute() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return null;
  }
  return <ItineraryOverview tripId={id} />;
}

export function DetailsFormRoute() {
  const { id } = useParams<{ id: string }>();
  return <DetailsForm tripId={id} />;
}
